__turbopack_context__.v({
  "line": "style-module-scss-module__Tx7-0W__line",
  "lineInner": "style-module-scss-module__Tx7-0W__lineInner",
  "section": "style-module-scss-module__Tx7-0W__section",
  "text": "style-module-scss-module__Tx7-0W__text",
  "title": "style-module-scss-module__Tx7-0W__title",
});
